import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import Spinner from "../../../components/ui/spinner";
import { getUsersRange } from "../../../services/apiservices/support";
import { Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const AccountTypesCard = ({ timeRange }) => {
  const [accountTypes, setAccountTypes] = useState();
  const [loading, setLoading] = useState(true);

  const planCounts = {
    Standard: 0,
    Plus: 0,
    Professional: 0,
  };

  const BASE_PRICE_MAP = [
    { name: "Free", amount: 0 },
    { name: "Standard", amount: 9900 },
    { name: "Plus", amount: 24900 },
    { name: "Professional", amount: 37500 },
    { name: "Standard", amount: 99000 },
    { name: "Plus", amount: 249900 },
    { name: "Professional", amount: 375000 },
  ];
  const PRICE_IDS_BY_ENV = {
    dev: [
      "price_1Roe9PH54HzvHwSdFEwomMT8",
      "price_1RY2GjH54HzvHwSd7xIHfw9Z",
      "price_1RY2L2H54HzvHwSdeCNKydVJ",
      "price_1RY2SdH54HzvHwSdE62LQFMq",
      "price_1RYSEYH54HzvHwSdWnZO85Pk",
      "price_1RYSH0H54HzvHwSdPNwhG0Zf",
      "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
    ],
    stage: [
      "price_1RoeHcHG9KfCFcBtNO24WZi1",
      "price_1Rg4StHG9KfCFcBtk62AyLjl",
      "price_1Rg4VOHG9KfCFcBtUdpounGQ",
      "price_1Rg4YeHG9KfCFcBthKGhErSl",
      "price_1Rg4TIHG9KfCFcBti234fUD6",
      "price_1Rg4VsHG9KfCFcBtOKbt91yg",
      "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
    ],
    prod: [
      "price_1RsdExHPX5Uwv3eVvXeq6n3a",
      "price_1RsdHLHPX5Uwv3eVePGNLRLj",
      "price_1RsdPgHPX5Uwv3eV7k7eyln8",
      "price_1RsdVFHPX5Uwv3eVbavvVBji",
      "price_1RsdLlHPX5Uwv3eV3ozmcddw",
      "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
      "price_1RsdVaHPX5Uwv3eVGScEMH75",
    ],
  };
  const ENV = process.env.REACT_APP_CUSTOM_ENV || "dev";

  const priceIds = PRICE_IDS_BY_ENV[ENV];
  const priceIdToPlanName = {};

  priceIds?.forEach((id, index) => {
    priceIdToPlanName[id] = BASE_PRICE_MAP[index]?.name;
  });

  const planColors = {
    Free: "#8dd1e1",
    Standard: "#8884d8",
    Plus: "#82ca9d",
    Professional: "#ffc658",
  };

  useEffect(() => {
    setAccountTypes();
    setLoading(true);
    getUsersRange(timeRange, "all", false, true).then((data) => {
      for (const user of data || []) {
        if (user?.role === "companyUser") {
          const subscriptions = user.subscriptions?.data || [];

          for (const sub of subscriptions) {
            let planName = null;

            if (sub.status === "trialing" || sub.status === "active") {
              const priceId = sub?.items?.data?.[0]?.price?.id;
              planName = priceIdToPlanName[priceId] || "Standard";
            }

            if (planName && planCounts[planName] !== undefined) {
              planCounts[planName]++;
            }
          }
        }
      }
      const accountTypeData = Object.entries(planCounts)?.map(
        ([name, value]) => ({
          name,
          value,
          color: planColors[name] || "#ccc",
        })
      );
      setAccountTypes(accountTypeData);
      setLoading(false);
    });
  }, [timeRange]);

  return (
    <Card className="bg-white dark:bg-[#2c3440] p-24">
      <CardHeader className="p-24">
        <CardTitle>Account Types Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Spinner size="lg" />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={accountTypes}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {accountTypes?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry?.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default AccountTypesCard;
